import type { Action, Dispatch } from 'redux';

import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getRequestID } from 'components/shared/util/request';
import { ActionNodeT } from 'fable/flowEditor';

import { FlowCallActionT } from '../api/types';
import { SET_NODES } from '../constants/actionTypes';

/**
 * Used to build a blank flow with a parent and an action node.
 *
 * @returns {[object] | undefined} Dispatch redux action creator addNode with
 *   the two nodes
 */
export function initBuild() {
  return (dispatch: Dispatch<Action>) => {
    const initNodeId = getRequestID();
    const node2ndId = getRequestID();

    const nodes: Record<string, FlowCallActionT | ActionNodeT> = {
      [initNodeId]: {
        badges: [],
        childIds: [],
        connectionLabel: 'arrow',
        icon: null,
        id: initNodeId,
        isAction: false,
        isEditable: false,
        isRemovable: false,
        nodeType: FlowNodeTypes.INIT,
        overlay: [],
        pageX: 0,
        pageY: 0,
        parentId: null,
        payload: null,
        text: 'Incoming Call',
      },
      [node2ndId]: {
        badges: [],
        childIds: [],
        connectionLabel: 'arrow',
        icon: null,
        id: node2ndId,
        isAction: false,
        isEditable: false,
        isRemovable: false,
        nodeType: FlowNodeTypes.ACTION,
        overlay: [],
        pageX: 113,
        pageY: 84,
        parentId: initNodeId,
        payload: null,
        text: '',
      },
    };

    dispatch({ type: SET_NODES, nodes });
  };
}
